import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { ImmutableStopwatchInfo } from '../../classes/timeTracking/ImmutableStopwatch/ImmutableStopwatch';
import { useStopwatchManager } from './useStopwatchManager';
export function useStopwatchInfos() {
  const $ = _c(5);
  const manager = useStopwatchManager();
  let t0;
  if ($[0] !== manager) {
    t0 = manager.getStopwatchInfos();
    $[0] = manager;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [infos, setInfos] = useState(t0);
  let t1;
  let t2;
  if ($[2] !== manager) {
    t1 = () => {
      const disposable = manager.onStopwatchInfosChanged(setInfos);
      return () => disposable.dispose();
    };
    t2 = [manager, setInfos];
    $[2] = manager;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return infos;
}